import { useEffect, useState } from 'react';

// A ticking "now" for elapsed-time displays (OLIO-2602): the clock advances on its own
// cadence instead of riding the data-fetch cadence — with polling demoted in favor of
// live updates, an elapsed column would otherwise freeze between server events.
//
// `enabled` (default true) stops the interval — and the re-renders it drives — for a caller
// that stays mounted while hidden (e.g. a slideout kept in the DOM for its close animation).
export default function useNow(intervalMs = 30_000, enabled = true): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (!enabled) return;
    // Re-seed on every enable, not just at mount — a caller that mounts disabled (open=false)
    // and enables later would otherwise keep showing the mount-time value until the first tick.
    setNow(new Date());
    const timer = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs, enabled]);

  return now;
}
